import { DateTime } from "luxon";
export function getCurrentDate(zone) {
  let now = DateTime.local();
  if (zone && DateTime.local().setZone(zone).isValid) {
    return now.setZone(zone);
  }
  return now;
}
export function getDateTz(time, zone) {
  if (zone && DateTime.local().setZone(zone).isValid) {
    return time.setZone(zone);
  }
  return time;
}
export function isTimestampAfterCurrentDate(timeStamp, currentDateZone) {
  if (!timeStamp) return false;
  let now = getCurrentDate(currentDateZone);
  return DateTime.fromJSDate(new Date(timeStamp.seconds * 1000)) >= now;
}
export function isTimestampAfterDate(time, timeStamp, currentDateZone) {
  if (!timeStamp) return false;
  return (
    DateTime.fromJSDate(new Date(timeStamp.seconds * 1000)) >=
    time.setZone(currentDateZone)
  );
}
export function isAfterCurrentDate(targetDate, currentDateZone) {
  if (!targetDate) return false;
  let now = getCurrentDate(currentDateZone);
  return targetDate >= now;
}
export function isTimestrAfterCurrentDate(timeStr, currentDateZone) {
  if (!timeStr) return false;
  let now = getCurrentDate(currentDateZone);
  return (
    new DateTime.fromFormat(timeStr, "HH:mm:ss") >=
    new DateTime.fromFormat(now.toFormat("HH:mm:ss"), "HH:mm:ss")
  );
}
export function isMenuAvailable(storeDoc, menuTimeSetting) {
  let now = getCurrentDate(storeDoc.TimezoneIanaFormat);
  if (
    menuTimeSetting.DayOfWeek.toLowerCase() !=
    now.toFormat("cccc").toLowerCase()
  ) {
    return false;
  }
  if (
    !isTimestrAfterCurrentDate(
      menuTimeSetting.StartTime,
      storeDoc.TimezoneIanaFormat
    ) &&
    isTimestrAfterCurrentDate(
      menuTimeSetting.EndTime,
      storeDoc.TimezoneIanaFormat
    )
  ) {
    return true;
  } else {
    return false;
  }
}
export function operatingHours(storeDoc, date) {
  if (!date) date = DateTime.local();
  if (storeDoc.TimezoneIanaFormat)
    date = date.setZone(storeDoc.TimezoneIanaFormat);
  let operatinHours = "";
  storeDoc.OperatingHours.forEach(item => {
    if (item.DayOfWeek.toLowerCase() == date.toFormat("cccc").toLowerCase()) {
      operatinHours = item;
    }
  });
  if (operatinHours) {
    let offset = DateTime.local().offset - date.offset;
    return {
      openTime: DateTime.fromFormat(operatinHours.OpeningTime, "HH:mm:ss")
        .plus({ minutes: offset })
        .toFormat("hh:mm a"),
      closeTime: DateTime.fromFormat(operatinHours.ClosingTime, "HH:mm:ss")
        .plus({ minutes: offset })
        .toFormat("hh:mm a")
    };
  }
  return null;
}
export function initPickupDeliveryTimes(storeDoc) {
  var date = DateTime.local();
  if (storeDoc.TimezoneIanaFormat)
    date = date.setZone(storeDoc.TimezoneIanaFormat);
  if (storeDoc.PreOrderPreparationTime > 0) {
    var nextOpenDate = getNexOpenDate(
      storeDoc,
      new DateTime.local().plus({ hours: storeDoc.PreOrderPreparationTime })
    );
    if (nextOpenDate.toISODate() != date.toISODate()) {
      date = DateTime.fromISO(date.toISODate());
    }
  }
  let operatinHours = "";
  storeDoc.OperatingHours.forEach(item => {
    if (item.DayOfWeek.toLowerCase() == date.toFormat("cccc").toLowerCase()) {
      operatinHours = item;
    }
  });
  let startingTime = operatinHours.OpeningTime;
  let closingTime = operatinHours.ClosingTime;
  var closingDateTime = DateTime.fromFormat(
    date.toFormat("dd MMMM yyyy") + " " + closingTime,
    "dd MMMM yyyy hh:mm:ss"
  );
  var startingDateTime = DateTime.fromFormat(
    date.toFormat("dd MMMM yyyy") + " " + startingTime,
    "dd MMMM yyyy hh:mm:ss"
  );
  return populateTimes(startingDateTime, closingDateTime, storeDoc, date);
}
export function populateTimes(
  startingDateTime,
  closingDateTime,
  storeDoc,
  date
) {
  var times = new Array();
  if (startingDateTime < date) startingDateTime = date;
  var orderPrepartionTime = storeDoc.OrderPreparationTime || 0;
  startingDateTime.plus({ minutes: orderPrepartionTime });
  let nextTime = startingDateTime.plus({ minutes: 20 });
  do {
    times.push(nextTime.toFormat("h:mm a"));
    // plus 20 minutes
    nextTime = nextTime.plus({ minutes: 20 });
  } while (nextTime <= closingDateTime);
  return times;
}
export function availablePickupDeliveryDates(storeDoc, date) {
  var startDate = date;
  if (storeDoc.PreOrderPreparationTime > 0) {
    startDate = getNexOpenDate(
      storeDoc,
      date.plus({ hours: storeDoc.PreOrderPreparationTime })
    );
  }
  var disableAfter = startDate.plus({ days: 14 });
  return createDisableDates(startDate, disableAfter, storeDoc);
}
export function createDisableDates(startDate, twoWeekAfter, storeDoc) {
  return {
    customPredictor: function (date) {
      if (!IsStoreOpenOnDate(storeDoc, date)) {
        return true;
      }
      if (date < startDate) {
        return true;
      }
      if (date > twoWeekAfter) {
        return true;
      } else {
        return false;
      }
    }
  };
}

export function IsStoreOpenOnDate(storeDoc, date) {
  let day = new Date(date).getDay();
  var DayOfWeekLabel = "";
  switch (day) {
    case 0:
      DayOfWeekLabel = "Sunday";
      break;
    case 1:
      DayOfWeekLabel = "Monday";
      break;
    case 2:
      DayOfWeekLabel = "Tuesday";
      break;
    case 3:
      DayOfWeekLabel = "Wednesday";
      break;
    case 4:
      DayOfWeekLabel = "Thursday";
      break;
    case 5:
      DayOfWeekLabel = "Friday";
      break;
    case 6:
      DayOfWeekLabel = "Saturday";
      break;
  }
  let result = false;

  if (!storeDoc.IsInOperation) {
    return false;
  }

  storeDoc.OperatingHours.forEach(item => {
    if (item.DayOfWeek.toLowerCase() == DayOfWeekLabel.toLowerCase()) {
      result = true;
    }
  });
  return result;
}

export function IsStoreOpenAtTime(storeDoc, date) {
  let OpenOnDate = IsStoreOpenOnDate(storeDoc, date);

  let now = getCurrentDate(storeDoc.TimezoneIanaFormat);
  if (OpenOnDate) {
    let operatinHours = null;
    storeDoc.OperatingHours.forEach(item => {
      if (item.DayOfWeek.toLowerCase() == now.toFormat("cccc").toLowerCase()) {
        operatinHours = item;
      }
    });
    if (!operatinHours) return false;
    if (
      !isTimestrAfterCurrentDate(
        operatinHours.OpeningTime,
        storeDoc.TimezoneIanaFormat
      ) &&
      isTimestrAfterCurrentDate(
        operatinHours.ClosingTime,
        storeDoc.TimezoneIanaFormat
      )
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function getNexOpenDate(storeDoc, startDate) {
  var index = -1;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    index++;
    let today = startDate
      .plus({ days: index })
      .toJSDate()
      .getDay();
    let operatinHours = storeDoc.OperatingHours[today];
    if (
      !operatinHours ||
      !operatinHours.OpeningTime ||
      !operatinHours.ClosingTime
    )
      continue;
    let now = startDate.plus({ days: index }).toUTC();
    let opening = DateTime.fromFormat(
      now.toFormat("yyyy/MM/dd") + " " + operatinHours.OpeningTime,
      "yyyy/MM/dd hh:mm:ss"
    ).toUTC();
    let closing = DateTime.fromFormat(
      now.toFormat("yyyy/MM/dd") + " " + operatinHours.ClosingTime,
      "yyyy/MM/dd hh:mm:ss"
    ).toUTC();
    if (index > 0) {
      return DateTime.fromFormat(
        now.toFormat("yyyy/MM/dd") + " " + operatinHours.OpeningTime,
        "yyyy/MM/dd hh:mm:ss"
      ).toUTC();
    }
    if (now >= opening && now <= closing) {
      return now;
    }
  }
}
export function getDayOfWeekLabel(day) {
  let DayOfWeekLabel = "";
  switch (day) {
    case 0:
      DayOfWeekLabel = "Sunday";
      break;
    case 1:
      DayOfWeekLabel = "Monday";
      break;
    case 2:
      DayOfWeekLabel = "Tuesday";
      break;
    case 3:
      DayOfWeekLabel = "Wednesday";
      break;
    case 4:
      DayOfWeekLabel = "Thursday";
      break;
    case 5:
      DayOfWeekLabel = "Friday";
      break;
    case 6:
      DayOfWeekLabel = "Saturday";
      break;
  }
  return DayOfWeekLabel;
}
export function getDayOfWeekSurcharge(time, storeZone) {
  let now = time.setZone(storeZone);
  let DayOfWeekLabel = 0;
  switch (now.toFormat("cccc").toLowerCase()) {
    case "monday":
      DayOfWeekLabel = 1;
      break;
    case "tuesday":
      DayOfWeekLabel = 2;
      break;
    case "wednesday":
      DayOfWeekLabel = 3;
      break;
    case "thursday":
      DayOfWeekLabel = 4;
      break;
    case "friday":
      DayOfWeekLabel = 5;
      break;
    case "saturday":
      DayOfWeekLabel = 6;
      break;
    case "sunday":
      DayOfWeekLabel = 7;
      break;
  }
  return DayOfWeekLabel;
}
